import React from 'react';

export const FORCE_CLOSE_EVENT = 'force_close_select';

export function useForceCloseEvent(cb: (open: boolean) => void) {
  React.useEffect(() => {
    const onLoadingEvent = (event: Event) => {
      if (event.type === FORCE_CLOSE_EVENT) {
        cb(false);
      }
    };

    document.addEventListener(FORCE_CLOSE_EVENT, onLoadingEvent);

    // cleanup this component
    return () => {
      document.removeEventListener(FORCE_CLOSE_EVENT, onLoadingEvent);
    };
  }, [cb]);
}
